var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1545 4.88672H17.4248V18.9378C17.4248 19.1132 17.2826 19.2556 17.107 19.2556H6.71729V19.9853C6.71729 20.1609 6.85946 20.303 7.03502 20.303H18.1547C18.3303 20.303 18.4725 20.1609 18.4725 19.9853V5.20424C18.4724 5.16251 18.4642 5.1212 18.4482 5.08266C18.4322 5.04413 18.4088 5.00912 18.3792 4.97963C18.3497 4.95015 18.3147 4.92677 18.2761 4.91082C18.2376 4.89488 18.1962 4.88669 18.1545 4.88672Z",
    fill: "#010D2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3775 17.8918V3.1107C16.3775 2.93514 16.2353 2.79297 16.0598 2.79297H15.33V16.8443C15.33 17.0198 15.1878 17.162 15.0123 17.162H4.62231V17.8918C4.62231 18.0673 4.76448 18.2095 4.94004 18.2095H16.0598C16.2353 18.2095 16.3775 18.0673 16.3775 17.8918Z",
    fill: "#010D2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2827 15.7941V1.01304C14.2827 0.837482 14.1405 0.695312 13.9649 0.695312H2.84544C2.66988 0.695312 2.52771 0.837482 2.52771 1.01304V15.7941C2.52771 15.9697 2.66988 16.1118 2.84544 16.1118H13.9649C14.1405 16.1118 14.2827 15.9697 14.2827 15.7941Z",
    fill: "#010D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkAct);
export default __webpack_public_path__ + "static/media/bulk-act.c48c2873bcd58ce58b9746920246cb98.svg";
export { ForwardRef as ReactComponent };